import React, { useEffect, useState } from "react";
import "./Kid.css";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

export const ParentInvitationSetup = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [searchParams] = useSearchParams();

  const extracted = {
    expires: searchParams.get("expires"),
    hash: searchParams.get("hash"),
    kid_limit: searchParams.get("kid_limit"),
    role: searchParams.get("role"),
    token: searchParams.get("token"),
    user_id: searchParams.get("user_id"),
    signature: searchParams.get("signature"),
    months_valid:searchParams.get("months_valid")
  };
//   console.log(extracted);
  const [kids, setKids] = useState([]);
  useEffect(() => {
    // Example: kid_limit comes from URL or props
    const params = new URLSearchParams(window.location.search);
    const kidLimit = parseInt(params.get("kid_limit") || "1", 10);

    // Create array with `kidLimit` empty kid objects
    const kidsArray = Array.from({ length: kidLimit }, () => ({
      fName: "",
      lName: "",
      age: "",
      email: "",
      password: "",
      kidpasswordValid: true,
      showCurrentKidPassword: false,
      kidUserNameValid: true,
    }));

    setKids(kidsArray);
  }, []);
  const { kidCount } = useParams();
  const navigate = useNavigate();
  const handleAddKid = () => {
    const kidLimit = Number(kidCount) || 5; // fallback max = 5

    if (kids.length < kidLimit) {
      setKids([
        ...kids,
        {
          fName: "",
          lName: "",
          age: "",
          email: "",
          password: "",
          kidpasswordValid: true,
          showCurrentKidPassword: false,
          kidUserNameValid: true,
        },
      ]);
    } else {
      toast.error(`You can only have up to ${kidLimit} kids.`);
    }
  };
//   console.log("Kids length:", kids.length, extracted.kid_limit);

  const handleRemoveKid = (index) => {
    if (kids.length > 1) {
      const updatedKids = kids.filter((_, i) => i !== index);
      setKids(updatedKids);
    } else {
      toast.error("At least one kid is required.");
    }
  };
  //   const handleRemoveKid = (index) => {
  //     setKids((prevKids) => prevKids.filter((_, i) => i !== index));
  //   };

  const handleInputChange = (index, field, value) => {
    const updatedKids = kids.map((kid, i) => {
      if (i !== index) return kid;

      const updatedKid = { ...kid, [field]: value };

      if (field === "password") {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        updatedKid.kidpasswordValid = regex.test(value);
      }
      if (field === "username") {
        const trimmedValue = value.trim();

        // Check for length >= 5 and no spaces
        if (trimmedValue.length < 5 || /\s/.test(value)) {
          updatedKid.kidUserNameValid = false;
        } else {
          updatedKid.kidUserNameValid = true;
        }
      }
      return updatedKid;
    });

    setKids(updatedKids);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let allValid = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    const updatedKids = kids.map((kid) => {
      const isPasswordValid = passwordRegex.test(kid.password);
      const isUsernameValid = kid.kidUserNameValid;

      // Set overall form validity
      if ((!isPasswordValid || !isUsernameValid) && kid.age < 13) {
        allValid = false;
      }

      return {
        ...kid,
        kidpasswordValid: isPasswordValid,
        kidUserNameValid: isUsernameValid,
      };
    });

    setKids(updatedKids);

    if (!allValid) {
      // Show error or scroll to the first invalid input
      return;
    }
      const payload = {
          kid_limit: extracted.kid_limit,
          hash: extracted.hash,
        role: "parent",
        months_valid:extracted.months_valid,
          expires:extracted.expires,
      kids: kids.map(({ fName, lName, age, email, username, password }) => ({
        fName,
        lName,
        age,
        ...(Number(age) >= 13 && { email }), // Include email if age >= 13
        ...(Number(age) < 13 && { password }), // Include password if age < 13
        ...(Number(age) < 13 && { username }),
      })),
    };
    try {
      const response = await fetch(`${apiUrl}/partner-accounts/parent/store-kids`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${extracted.token}`, // add token here
          },
        body: JSON.stringify(payload),
      });

      const data = await response.json(); // ✅ Read once

      if (!response.ok) {
        if (data?.errors) {
          Object.entries(data.errors).forEach(([field, messages]) => {
            messages.forEach((message) => {
              // Optional: make the field name prettier
              const prettyField = field.replace(
                /kids\.(\d+)\./,
                (_, i) => `Kid ${+i + 1} `
              );
              toast.error(`${prettyField}: ${message}`);
            });
          });
        } else {
          toast.error(data?.message || "Signup failed!");
        }
        return;
      }
        if (response.ok) {
            toast.success(data.message)
            navigate("/setup-partner-account/verified")
      }
      // ✅ Successful flow (201 or 200)
    //   localStorage.setItem("number_of_kids", kids?.length);
    //   const studentIds = data?.kids?.map((kid) => kid.id).join(",") || "";
    //   localStorage.setItem("student_ids", studentIds);
    //   navigate("/parent/payment/update");
      setKids([{ name: "", age: "", email: "" }]);
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <section className="LoginCard">
      <div className="container">
        {" "}
        <div className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-8">
            <div className="text-center d-none d-md-block">
              <img
                className="img-fluid"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogoPlainBig.png"
                alt="logo"
              />
            </div>
            <div className="text-center d-block d-md-none">
              <img
                className="img-fluid"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogoPlain.png"
                alt="logo"
              />
            </div>
            <div className="text-center mt-4">
              <p className="fs-3">Connect your kid with Yuva Quest</p>
            </div>
            <form onSubmit={handleSubmit}>
              {kids.map((kid, index) => (
                <div className="container my-4" key={index}>
                  <div className="row position-relative">
                    <div
                      className="col-auto"
                      style={{ paddingLeft: "20px", paddingRight: "0" }}
                    >
                      {/* Continuous vertical gray line */}
                      <div
                        style={{
                          position: "absolute",
                          top: index === 0 ? "20px" : "-20px", // Pull up to connect line
                          bottom: index === kids.length - 1 ? "0" : "-20px", // Stretch down to connect
                          left: "14px",
                          width: "2px",
                          backgroundColor: "#AAAAAA",
                          zIndex: 0,
                        }}
                      ></div>

                      {/* Blue dot aligned with header */}
                      <div
                        style={{
                          position: "absolute",
                          top: "20px", // Align with header
                          left: "5px",
                          width: "20px",
                          height: "20px",
                          backgroundColor: "#008EF4",
                          borderRadius: "50%",
                          zIndex: 1,
                        }}
                      ></div>
                    </div>
                    <div className="col ps-3" id={`kid-${index}`}>
                      <div className="card shadow border-0 rounded-4 overflow-hidden">
                        <div
                          style={{ backgroundColor: "#008EF4" }}
                          className="text-white d-flex justify-content-between align-items-center p-3"
                        >
                          <h5 className="mb-0">
                            <strong>Kid {index + 1}</strong>
                          </h5>
                        </div>
                        <div className="card-body bg-white p-4">
                          <div key={index} className="row">
                            <div className="col-md-6 mt-2 mb-3">
                              <label
                                htmlFor={`fName-${index}`}
                                className="form-label"
                              >
                                Kid's First Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                style={{ borderRadius: "20px" }}
                                id={`fName-${index}`}
                                value={kid.fName}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "fName",
                                    e.target.value
                                  )
                                }
                                required
                              />
                            </div>
                            <div className="col-md-6 mt-2 mb-3">
                              <label
                                htmlFor={`lName-${index}`}
                                className="form-label"
                              >
                                Kid's Last Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id={`lName-${index}`}
                                style={{ borderRadius: "20px" }}
                                value={kid.lName}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "lName",
                                    e.target.value
                                  )
                                }
                                required
                              />
                            </div>
                            <div className="col-md-6 mt-2 mb-3">
                              <label
                                htmlFor={`age-${index}`}
                                className="form-label"
                              >
                                Kid's Age
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                id={`age-${index}`}
                                style={{ borderRadius: "20px" }}
                                value={kid.age}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "age",
                                    e.target.value
                                  )
                                }
                                required
                                min="1"
                              />
                            </div>
                            {Number(kid.age) < 13 && (
                              <div className="col-md-12 mt-2 mb-3">
                                <label
                                  htmlFor={`username-${index}`}
                                  className="form-label"
                                >
                                  Kid's Username
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`username-${index}`}
                                  value={kid.username}
                                  style={{ borderRadius: "20px" }}
                                  maxLength={15}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "username",
                                      e.target.value
                                    )
                                  }
                                  required
                                />
                                {kid.kidUserNameValid === false && (
                                  <div className="invalid-feedback d-block">
                                    Username length must be more than 5
                                    character and no space allowed
                                  </div>
                                )}
                              </div>
                            )}
                            {Number(kid.age) < 13 && (
                              <div className="col-md-12 mt-2 mb-3">
                                <label
                                  htmlFor={`password-${index}`}
                                  className="form-label"
                                >
                                  Kid's Password
                                </label>
                                <div className="position-relative">
                                  <input
                                    type={
                                      kid.showCurrentKidPassword
                                        ? "text"
                                        : "password"
                                    }
                                    className={`form-control ${
                                      kid.kidpasswordValid === false
                                        ? "is-invalid no-validation-icon"
                                        : ""
                                    }`}
                                    id={`password-${index}`}
                                    value={kid.password}
                                    style={{ borderRadius: "20px" }}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "password",
                                        e.target.value
                                      )
                                    }
                                    required
                                  />
                                  <span
                                    className="position-absolute top-50 translate-middle-y"
                                    style={{ right: "15px", cursor: "pointer" }}
                                    onClick={() => {
                                      const updatedKids = kids.map((k, i) => {
                                        if (i !== index) return k;
                                        return {
                                          ...k,
                                          showCurrentKidPassword:
                                            !k.showCurrentKidPassword,
                                        };
                                      });
                                      setKids(updatedKids);
                                    }}
                                  >
                                    <i
                                      className={`fa ${
                                        kid.showCurrentKidPassword
                                          ? "fa-eye"
                                          : "fa-eye-slash"
                                      }`}
                                    ></i>
                                  </span>
                                </div>

                                {kid.kidpasswordValid === false && (
                                  <div className="invalid-feedback d-block">
                                    Password must be at least 8 characters long
                                    and contain at least one uppercase letter,
                                    one lowercase letter, one number, and one
                                    special character.
                                  </div>
                                )}
                              </div>
                            )}
                            {Number(kid.age) >= 13 && (
                              <div className="col-md-12 mt-2 mb-3">
                                <label
                                  htmlFor={`email-${index}`}
                                  className="form-label"
                                >
                                  Kid's Email
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  id={`email-${index}`}
                                  value={kid.email}
                                  style={{ borderRadius: "20px" }}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "email",
                                      e.target.value
                                    )
                                  }
                                  required
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ backgroundColor: "#008EF4" }}
                  onClick={handleAddKid}
                  disabled={kids.length >= Number(extracted.kid_limit)} // auto re-checks after removal
                >
                  {kids.length < Number(extracted.kid_limit)
                    ? `Add Kid (${kids.length + 1} of ${extracted.kid_limit})`
                    : "Kid Limit Reached"}
                </button>

                {kids.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => handleRemoveKid(kids.length - 1)}
                  >
                    Remove Kid
                  </button>
                )}
              </div>

              <button type="submit" className="kidRegistrSubmtBtn mt-4 mb-5">
                Submit
              </button>
            </form>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </section>
  );
};
